import React, { useState } from 'react';

export default function HelpDiagram({ diagram }) {
  const [failed, setFailed] = useState(false);
  return <figure className="help-diagram">
    <figcaption><strong>{diagram.title}</strong><p>{diagram.description}</p></figcaption>
    {!failed && <p className="mt-2"><a href={diagram.image} target="_blank" rel="noopener noreferrer" aria-label={`Open larger diagram: ${diagram.title}`}>Open larger diagram <span className="sr-only">(new tab)</span></a><span className="block sm:hidden text-sm help-muted mt-2">Swipe sideways to see the full diagram, or open it larger.</span></p>}
    {!failed && <div className="help-diagram-viewport" tabIndex={0} role="region" aria-label={`${diagram.title} diagram; scroll sideways on small screens`}><img src={diagram.image} alt={diagram.description} onError={() => setFailed(true)} loading="lazy" /></div>}
    {failed && <p role="status">Diagram unavailable. Follow the explanation and task steps provided here.</p>}
  </figure>;
}
